import { Grid, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';

const GridSize = { xs: 12, md: 3 };

type StatsCardProps = {
  title: string;
  value: string | number;
  success?: boolean;
};

export const StatsCard = ({
  title,
  value,
  success = false,
}: StatsCardProps) => {
  const color = success ? 'success' : 'inherit';

  return (
    <Grid size={GridSize}>
      <ContentBox height="100%" justifyContent="center" alignItems="center">
        <Typography textAlign="center" color={color}>
          {title}
        </Typography>
        <Typography
          textAlign="center"
          color={color}
          fontWeight="medium"
          fontSize="24px"
        >
          {value}
        </Typography>
      </ContentBox>
    </Grid>
  );
};
